"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ConfigContext } from "#/context";
import { CodePanel } from "#/features/codeRunner/ui/CodePanel";
import { OutputPanel } from "#/features/output/ui/OutputPanel";
import { PlaygroundViewProvider } from "#/features/playground/context/PlaygroundViewContext";
import { usePlaygroundMobileLayout } from "#/features/playground/hooks/usePlaygroundMobileLayout";
import { MobilePlayground } from "#/features/playground/ui/MobilePlayground";
import { PlaygroundPanelsGate } from "#/features/playground/ui/PlaygroundPanelsGate";
import { ProjectPanel } from "#/features/project/ui/ProjectPanel";
import { TreeViewPanel } from "#/features/treeViewer/ui/TreeViewPanel";
import { useAppConfig } from "#/shared/hooks";
import { SplitPanelsLayoutClient } from "#/shared/ui/templates/SplitPanelsLayout/SplitPanelsLayoutClient";

/** Playground shell — desktop split layout or mobile phased UI inside shared chrome. */
export const PlaygroundPageView: React.FC = () => {
  const $ = _c(7);
  const isMobile = usePlaygroundMobileLayout();
  const {
    data: t0
  } = useAppConfig();
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const data = t1;
  let t2;
  if ($[2] !== isMobile) {
    t2 = <PlaygroundPanelsGate>{isMobile ? <PlaygroundViewProvider><MobilePlayground /></PlaygroundViewProvider> : <SplitPanelsLayoutClient component="main" TopLeft={ProjectPanel} BottomLeft={CodePanel} TopRight={TreeViewPanel} BottomRight={OutputPanel} />}</PlaygroundPanelsGate>;
    $[2] = isMobile;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== data || $[5] !== t2) {
    t3 = <ConfigContext.Provider value={data}>{t2}</ConfigContext.Provider>;
    $[4] = data;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};